export class CdtFrontElement {
    get x() {
        return this.LeftSite.point.x;
    }
    constructor(leftSite, edge) {
        /*Assert.assert(
          (edge.upperSite.point.x !== edge.lowerSite.point.x &&
            edge.upperSite.point.x < edge.lowerSite.point.x &&
            leftSite === edge.upperSite) ||
            (edge.upperSite.point.x > edge.lowerSite.point.x &&
              leftSite === edge.lowerSite),
        )*/
        this.RightSite = edge.upperSite === leftSite ? edge.lowerSite : edge.upperSite;
        this.LeftSite = leftSite;
        this.Edge = edge;
    }
    toString() {
        return '(' + this.LeftSite.toString() + ', ' + this.Edge.toString() + ',' + this.RightSite.toString() + ')';
    }
}
//# sourceMappingURL=CdtFrontElement.js.map